<template>
    <v-layout row wrap class="m-onboard-step-objects">

        <v-flex xs12 pb-4 class="m-onboard-step-objects__texts" v-if="emptyObjects">
            <e-typography-body-small>{{$t('modules.onboards.m-onboard-step-objects.text-add-object')}}
            </e-typography-body-small>
        </v-flex>
        <v-flex xs12 pb-4 class="m-onboard-step-objects__texts" v-else-if="!emptyObjects">
            <e-typography-body-small>{{$t('modules.onboards.m-onboard-step-objects.text-choose-object')}}
            </e-typography-body-small>
        </v-flex>

        <div class="m-onboard-step-buttons-wrap">
            <div class="m-onboard-step-buttons object-buttons">
                <e-button-white v-if="panelState !== 1" tabindex="0" @click="submitChooseForm" class="mr-0">
                    Weiter
                </e-button-white>
                <e-button-white v-else-if="panelState == 1" tabindex="0" white @click="submitCreateForm" class="mr-0">
                    {{$t('modules.onboards.m-onboard-step-objects.save-and-continue')}}
                </e-button-white>
            </div>
        </div>

        <v-flex xs12>
            <v-expansion-panel v-model="panelState">
                <v-expansion-panel-content v-if="panelState !== 0 || !emptyObjects">
                    <m-stepper-object-choose
                            isOnboarding
                            :items="objects"
                            ref="chooseForm"
                            @setObjectId="setObjectId"/>
                    <v-layout wrap>
                        <v-layout>
                            <v-flex xs-12 md-6 class="m-onboard-step-objects__button-first">
                                <e-button-white v-if="panelState !== 1" tabindex="0" @click="toggle(1)" class="mt-3">
                                    {{$t('modules.onboards.m-onboard-step-objects.add-objects')}}
                                </e-button-white>
                            </v-flex>
                        </v-layout>
                        <v-layout mt-1>
                            <v-flex xs-12 md-6 class="buttons-submit m-onboard-step-objects__button-second">
                                <e-button-primary @click="submitChooseForm">Weiter</e-button-primary>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-if="panelState == 1 || emptyObjects">
                    <m-onboard-step-objects-create
                            isOnboarding
                            @submitObject="submitObject"
                            ref="createForm"/>
                    <v-layout wrap>
                        <v-layout mt-1>
                            <v-flex xs-12 md-6>
                                <e-button-white v-if="panelState !== 0" tabindex="0" @click="toggle(0)">
                                    {{$t('modules.onboards.m-onboard-step-objects.select-objects')}}
                                </e-button-white>
                            </v-flex>
                        </v-layout>
                        <v-layout mt-1>
                            <v-flex xs-12 md-6 class="buttons-submit">
                                <e-button-primary @click="submitCreateForm">
                                    {{$t('modules.onboards.m-onboard-step-objects.save-and-continue')}}
                                </e-button-primary>
                            </v-flex>
                        </v-layout>
                    </v-layout>

                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-flex>

    </v-layout>
</template>

<script>

    // IE11 Fix
    if (!('remove' in Element.prototype)) {
        Element.prototype.remove = function() {
            if (this.parentNode) {
                this.parentNode.removeChild(this);
            }
        };
    }

    import MOnboardStepObjectsCreate from "@modules/onboards/concrete/m-onboard-step-objects-create"
    import MStepperObjectChoose from "@modules/steppers/concrete/m-stepper-object-choose";
    import {createNamespacedHelpers} from 'vuex'
    import {isEmpty} from "lodash";
    import {PAGINATION} from '@constants/common';
    import ETypographyBodySmall from "@elements/typography/e-typography-body-small";
    import notifications from "@mixins/includes/_notifications";

    const {mapGetters, mapActions} = createNamespacedHelpers('objects');

    export default {
        name: "m-onboard-step-objects",
        components: {
            ETypographyBodySmall,
            MOnboardStepObjectsCreate,
            MStepperObjectChoose,
        },
        mixins: [notifications],
        data() {
            return {
                panelState: 0,
                query: {
                    sort: null,
                    pagination: {
                        currentPage: 1,
                        itemsPerPage: PAGINATION.CHUNK,
                        totalItems: 0
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                getObjects: 'list'
            }),
            emptyObjects() {
                return isEmpty(this.objects)
            },
            sortItems() {
                return [
                    {
                        text: this.$t('modules.sorts.m-sort-objects.alpha.asc'),
                        field: 'name.raw',
                        sortBy: 'name',
                        order: 'asc'
                    }, {
                        text: this.$t('modules.sorts.m-sort-objects.alpha.desc'),
                        field: 'name.raw',
                        sortBy: 'name',
                        order: 'desc'
                    }, {
                        text: this.$t('modules.sorts.m-sort-objects.created.desc'),
                        field: 'createdAt',
                        sortBy: 'createdAt',
                        order: 'desc'
                    }, {
                        default: true,
                        text: this.$t('modules.sorts.m-sort-objects.updated.desc'),
                        field: 'updatedAt',
                        sortBy: 'updatedAt',
                        order: 'desc'
                    }
                ]
            },

            objects() {
                return this.getObjects(this.query.sort);
            },

            creationRouteName() {
                return this.nav.dashboard.service.objects.create.name;
            }
        },
        async created() {
            this.query.sort = this.sortItems.find((item) => item.default);
        },
        methods: {
            ...mapActions({
                loadObjects: 'list',
                createObject: 'create'
            }),

            submitChooseForm() {
                this.$refs.chooseForm.chooseOnboardingObject();
            },

            submitCreateForm() {
                this.$refs.createForm.submit()
            },

            async submitObject(payload) {
                try {
                    let object = await this.createObject(payload);
                    this.setObjectId(object._id);
                    this.notify.success(this.$t('notifications.objects.created', {name: object.name}));
                    this.next();
                } catch (e) {
                    this.notify.processUnhandledError(e)
                }
            },

            setObjectId(id) {
                this.$emit('setObjectId', id);
            },

            async requestObjects() {
                this.query.pagination = await this.loadObjects({
                    sort: this.query.sort,
                    pagination: this.query.pagination
                });
            },

            next() {
                this.$emit('next')
            },

            toggle(el) {
                //this.panelState === el ? this.panelState = null : this.panelState = el;
                this.panelState = el;
            },
            placeButtons() {
                let removeButtons = document.querySelector('.employee-buttons');
                let addButtons = document.querySelector('.object-buttons');
                let target = document.querySelector('.m-onboard-header-buttons');
                if (document.body.contains(removeButtons)) {
                    removeButtons.remove();
                }
                if (target && addButtons) target.appendChild(addButtons)
            }
        },
        mounted() {
            this.placeButtons();
            let tst = document.querySelector('.m-onboard-step-objects .v-expansion-panel__container')
        },
        updated() {
            this.placeButtons()
        },
        watch: {
            objects(next, prev) {
                if (prev && prev.length > next.length) {
                    this.query.pagination.totalItems += (next.length - prev.length);
                }
            },
            'query.sort': function () {
                this.requestObjects();
            },
            'query.pagination': function (next, prev) {
                if (prev.currentPage !== next.currentPage) {
                    this.requestObjects();
                }
            }
        }
    }
</script>

<style lang="scss">
    .m-onboard-step-objects {
        &__texts {
            margin-top: -2rem;
        }

        &__button-first {
            @include updatedMedia(sm) {
                padding-left: 2rem !important;
                padding-right: 3rem !important;
            }
            @include updatedMedia(md) {
                padding-right: 3rem !important;
            }
        }

        &__button-second {
            @include updatedMedia(sm) {
                padding-left: 3rem !important;
                padding-right: 2rem !important;
            }
            @include updatedMedia(md) {
                padding-left: 3rem !important;
            }
        }

        .v-stepper {
            background: none;
        }

        .v-expansion-panel__container {
            border-top: none !important;
        }

        .v-expansion-panel {
            box-shadow: none;

            &__body {
                background: var(--v-secondary-base);
            }
        }

        .buttons-submit {
            justify-content: flex-end;
            display: flex;
        }
    }
</style>